import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import ResourceListPage from "@/pages/ResourceListPage";
import DispatchPreview from "@/pages/DispatchPreview";

const DELIVERY_CFG = {
  label: "Delivery / POD", path: "/delivery", testId: "delivery",
  endpoint: "/dispatch/delivered", idKey: "id",
  columns: [
    { key: "orderNo", label: "Order #", type: "mono" },
    { key: "buyerName", label: "Buyer", type: "text" },
    { key: "status", label: "Status", type: "badge" },
    { key: "deliveredAt", label: "Delivered At", type: "datetime" },
    { key: "receivedBy", label: "Received By", type: "text" },
  ],
  searchKeys: ["orderNo", "buyerName"],
};

// Dispatch & Delivery module (desktop). Same shared backend / ledger-backed inventory.
// Tabs: Dispatch (against orders, FG deduction), Delivery / POD, and Dispatch Preview.
export default function DispatchModule() {
  const [tab, setTab] = useState("dispatch");
  return (
    <Tabs value={tab} onValueChange={setTab} className="space-y-4">
      <TabsList data-testid="dispatch-tabs" className="bg-stone-100">
        <TabsTrigger value="dispatch" data-testid="dispatch-tab-dispatch">Dispatch</TabsTrigger>
        <TabsTrigger value="delivery" data-testid="dispatch-tab-delivery">Delivery / POD</TabsTrigger>
        <TabsTrigger value="preview" data-testid="dispatch-tab-preview">Preview</TabsTrigger>
      </TabsList>
      <TabsContent value="dispatch"><ResourceListPage /></TabsContent>
      <TabsContent value="delivery"><ResourceListPage itemOverride={DELIVERY_CFG} /></TabsContent>
      <TabsContent value="preview"><DispatchPreview /></TabsContent>
    </Tabs>
  );
}
